<template>
    <div class="flex flex-col text-center pb-4">
          <h5 class="text-lg font-semibold mb-4">Contact us</h5>
        </div>
        <div class="flex flex-col w-full gap-4 text-md">
            <div class="flex">
                <V3ImageComponent src="icons/phone-call.png" class="h-5 w-5 mr-6" />
                <p><a :href="'tel:' + phone" @click="() => handleClicks('phone', phone)">{{ phone }}</a></p>
                <!-- <p>{{ phone }}</p> -->
            </div>
            <UDivider />
            <div class= "flex">
                <V3ImageComponent src="icons/email.png" class="h-5 w-5 mr-6" />
                <p><a :href="'mailto:' + email" @click="() => handleClicks('email', email)">{{ email }}</a></p>
                <!-- <p>{{ email }}</p> -->
            </div>
            <UDivider />
            <div class="flex">
                <V3ImageComponent src="icons/whatsapp.png" class="h-5 w-5 mr-6" />
                <p><a :href="'https://wa.me/' + whatsapp" @click="() => handleClicks('whatsapp', whatsapp)">{{ whatsapp }}</a></p>
                <!-- <p>{{ whatsapp }}</p> -->
            </div>
            <div class="flex items-center justify-center mt-6">
                <p class="text text-sm flex text-center">Support is available from 7 AM to 11 PM. Email us, and we'll reply shortly.</p>
            </div>
        </div>
</template>
  
  <script setup lang="ts">
  
  const runtimeConfig = useRuntimeConfig();
  const phone = runtimeConfig.public.support.phone
  const whatsapp = runtimeConfig.public.support.whatsapp
  const email = runtimeConfig.public.support.email
  const { gtag } = useGtag();
  const auth = useAuth();
    const isAuthenticated = auth && auth.access_token;
    const userData = isAuthenticated ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    } : {
      user_name: null,
      user_phone: null,
      user_email: null
  };


  const handleClicks = (source: any, data: any) => {
    gtag('event', 'cta_event', {
      action: 'click',
      cta_name: source,
      contact_value: data,
      ...userData,
    });
  }
  
  
  useSeoMeta({
    title: `contactUs`
  });
  </script>
  <style>
  .text{
    color: #1778EB;
  }
</style>